<div
  *ngIf="!hide"
  [class.mobile-bottom-shell--has-my-shortcut]="showMyShortcut"
  [class.mobile-bottom-shell--native-ios]="nativeIos"
  class="mobile-bottom-shell">
  <div aria-hidden="true" class="mobile-bottom-spacer"></div>

  <nav
    (focusin)="showFooter()"
    [attr.aria-hidden]="scrollHidden ? 'true' : null"
    [attr.inert]="scrollHidden ? '' : null"
    [class.mobile-bottom-nav--scroll-hidden]="scrollHidden"
    [style.--mobile-nav-item-count]="navigationItems.length"
    aria-label="주요 서비스"
    class="mobile-bottom-nav">
    <a *ngIf="showMyShortcut" aria-label="마이부동산으로 이동" class="mobile-bottom-nav__my"
       routerLink="/my-real-estate">
      <img alt="" aria-hidden="true" draggable="false" height="24" src="assets/img/menu/mobile-menu-my.svg" width="24">
    </a>
    <button
      (click)="openBottomSheet(item.type)"
      *ngFor="let item of navigationItems"
      [attr.aria-current]="isActive(item) ? 'page' : null"
      [attr.aria-label]="item.label + ' 메뉴 열기'"
      [class.mobile-bottom-nav__item--active]="isActive(item)"
      class="mobile-bottom-nav__item"
      type="button">
      <span aria-hidden="true" class="mobile-bottom-nav__indicator">
        <img [src]="isActive(item) ? item.activeIcon : item.icon" alt="" draggable="false">
      </span>
      <span class="mobile-bottom-nav__label">{{ item.label }}</span>
    </button>
  </nav>
</div>
